import React from 'react';
import { NavLink } from 'react-router-dom';
import { FooterPartnerType } from './Footer.style';
import { ROUTES } from 'routes/routes';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Nav from 'react-bootstrap/Nav';

const Footer: React.FC = () => {
  return (
    <>
      <section>
        <Container className="text-center py-5">
          <Row className="justify-content-center gap-5 gap-lg-0">
            <Col
              xs={12}
              sm={5}
              lg={3}
              className="d-flex flex-column align-items-center"
            >
              <FooterPartnerType>Sponsor tytularny</FooterPartnerType>
              <div className="d-flex flex-fill justify-content-center align-items-center">
                <a href="https://www.orlen.pl/">
                  <img
                    src="/assets/img/logo/orlen.svg"
                    alt="ORLEN"
                    width={100}
                    height={100}
                    loading="lazy"
                  />
                </a>
              </div>
            </Col>
            <Col
              xs={12}
              sm={5}
              lg={3}
              className="d-flex flex-column align-items-center"
            >
              <FooterPartnerType>Patron</FooterPartnerType>
              <div className="d-flex flex-fill justify-content-center align-items-center">
                <a href="https://www.tvp.pl/">
                  <img
                    src="/assets/img/logo/tvp.svg"
                    alt="TVP"
                    width={100}
                    height={49}
                    loading="lazy"
                  />
                </a>
              </div>
            </Col>
            <Col
              xs={12}
              md={5}
              lg={3}
              className="d-flex flex-column align-items-center"
            >
              <FooterPartnerType>Organizator</FooterPartnerType>
              <div className="d-flex flex-fill justify-content-center align-items-center">
                <a href="https://reclimb.com/pl?utm_campaign=ligawspinaczkowa&utm_source=website&utm_medium=footer-logo">
                  <img
                    src="/assets/img/logo/reclimb.svg"
                    alt="Reclimb"
                    width={100}
                    height={100}
                    loading="lazy"
                  />
                </a>
              </div>
            </Col>
            <Col
              xs={12}
              md={5}
              lg={3}
              className="d-flex flex-column align-items-center"
            >
              <FooterPartnerType>Partnerzy</FooterPartnerType>
              <div
                className="d-flex flex-fill justify-content-center align-items-center gap-5
              "
              >
                <a href="https://www.halawspinaczkowa.pl/">
                  <img
                    src="/assets/img/logo/camp4.png"
                    alt="CAMP4"
                    width={100}
                    height={100}
                    loading="lazy"
                  />
                </a>
                <a href="https://arenamakak.pl/">
                  <img
                    src="/assets/img/logo/makak.png"
                    alt="Makak"
                    width={100}
                    height={100}
                    loading="lazy"
                  />
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <footer className="footer pb-5">
        <div className="position-relative w-100 opacity-50 mb-5">
          <span
            className="position-absolute top-0 start-0 w-100 h-1"
            style={{
              backgroundImage: `linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0) 54.17%, #ffffff 98.44%)`,
              backgroundSize: '100% 100%',
              backgroundRepeat: 'no-repeat',
            }}
          ></span>
          <span className="d-block w-100 h-1 bg-gradient-primary"></span>
        </div>
        <div className="container text-center">
          <Nav className="justify-content-center pt-3 pb-4" as="ul">
            <Nav.Item as="li">
              <Nav.Link as={NavLink} to={ROUTES.CONTACT}>
                Kontakt
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
      </footer>
    </>
  );
};

export default Footer;
